var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chicken-road-history" }, [
    _c("div", { staticClass: "history-container" }, [
      _c(
        "div",
        { staticClass: "history-header" },
        [
          _c(
            "router-link",
            {
              staticClass: "history-header__back",
              attrs: { to: { name: _vm.chickenRoadRouteName } },
            },
            [_c("i", { staticClass: "icon_new icon_arrowLeft" })]
          ),
          _c("span", { staticClass: "history-header__title" }, [
            _vm._v(_vm._s(_vm.currencyTypeLabel) + " Chicken Road 历史"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "history-card" }, [
        !_vm.isLg
          ? _c("div", { staticClass: "history-table-header" }, [
              _c("span", [_vm._v("游戏 ID")]),
              _c("span", [_vm._v("时间")]),
              _c("span", [_vm._v("模式")]),
              _c("span", [_vm._v("额度")]),
              _c("span", [_vm._v("奖励")]),
              _c("span", { staticClass: "text-right" }, [_vm._v("倍率")]),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "history-scroll content__scroll" },
          [
            !_vm.isLoading
              ? _vm._l(_vm.historyPageGames, function (game) {
                  return _c(
                    "div",
                    { key: game.id, staticClass: "history-row" },
                    [
                      !_vm.isLg
                        ? [
                            _c("div", { staticClass: "game-id" }, [
                              _c("span", { staticClass: "game-id__label" }, [
                                _vm._v("ID"),
                              ]),
                              _c("span", { staticClass: "game-id__value" }, [
                                _vm._v(_vm._s(game.id)),
                              ]),
                            ]),
                            _c("span", { staticClass: "game-date" }, [
                              _vm._v(_vm._s(_vm.formatDate(game.createdAt))),
                            ]),
                            _c("span", { staticClass: "game-mode" }, [
                              _vm._v(_vm._s(_vm.getModeText(game.mode))),
                            ]),
                            _c("div", { staticClass: "game-bet" }, [
                              _c("i", { staticClass: "icon_new icon_coin" }),
                              _c("span", [
                                _vm._v(_vm._s(_vm.formatBet(game.amount))),
                              ]),
                            ]),
                            _c("div", { staticClass: "game-win" }, [
                              _c("i", {
                                staticClass: "icon_new icon_coin",
                                class:
                                  game.status === 2
                                    ? "game-win--success"
                                    : "game-win--danger",
                              }),
                              _c(
                                "span",
                                {
                                  class:
                                    game.status === 2
                                      ? "game-win--success"
                                      : "game-win--danger",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.formatWin(game)) + " "
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "game-multiplier" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "game-multiplier__badge",
                                  class:
                                    game.status === 2
                                      ? "game-multiplier__badge--win"
                                      : "game-multiplier__badge--lose",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "game-multiplier__inner",
                                      class:
                                        game.status === 2
                                          ? "game-multiplier__inner--win"
                                          : "game-multiplier__inner--lose",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(game.ratio || "0") + "x"),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "history-row__mobile-left" },
                              [
                                _c("div", { staticClass: "game-id" }, [
                                  _c(
                                    "span",
                                    { staticClass: "game-id__label" },
                                    [_vm._v("ID")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "game-id__value" },
                                    [_vm._v(_vm._s(game.id))]
                                  ),
                                ]),
                                _c("span", { staticClass: "game-date" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatDate(game.createdAt))
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "history-row__mobile-right" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "history-row__mobile-info" },
                                  [
                                    _c("span", { staticClass: "game-mode" }, [
                                      _vm._v(
                                        _vm._s(_vm.getModeText(game.mode))
                                      ),
                                    ]),
                                    _c("div", { staticClass: "game-bet" }, [
                                      _c("i", {
                                        staticClass: "icon_new icon_coin",
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.formatBet(game.amount))
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _c("div", { staticClass: "game-multiplier" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "game-multiplier__badge",
                                      class:
                                        game.status === 2
                                          ? "game-multiplier__badge--win"
                                          : "game-multiplier__badge--lose",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "game-multiplier__inner",
                                          class:
                                            game.status === 2
                                              ? "game-multiplier__inner--win"
                                              : "game-multiplier__inner--lose",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(game.ratio || "0") + "x"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ],
                    ],
                    2
                  )
                })
              : _vm._l(_vm.preloadGames, function (_, index) {
                  return _c("div", {
                    key: index,
                    staticClass: "history-row history-row--skeleton",
                  })
                }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }